import { useParams } from "react-router-dom";
import { useFetching } from "../hooks/useFetching";
import { useEffect, useState } from "react";
import PostService from "../API/PostService";
import Loader from "./UI/Loader/Loader";

const PostIdPage = () => {
  const params = useParams();
  const [post, setPost] = useState(null);
  const [comments, setComments] = useState([]);

  const [fetchPostById, isLoading, error] = useFetching(async () => {
    const responce = await PostService.getById(params.id);
    setPost(responce.data);
  });

  const [fetchCommentsById, isComLoading, comError] = useFetching(async () => {
    const responce = await PostService.getCommentsById(params.id);
    console.log("response:", responce);
    setComments(responce.data);
  });

  useEffect(() => {
    console.log("useEffect in PostPageId: " + params.id);
    fetchPostById();
    console.log('fetch comments');
    
    fetchCommentsById();
  }, []);

   useEffect(() => {
    console.log("comments   : " , comments);
   
  }, [comments]);

  return (
    <div>
      <h1>
        page with id: {params.id}: {params.title}
      </h1>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <div>error loading {error}</div>
      ) : post !== null ? (
        <div>post data: {post.body}</div>
      ) : (
        <div> no post</div>
      )}
      <h1>Comments</h1>
      {isComLoading ? (
        <Loader />
      ) : comError ? (
        <div>error comments load</div>
      ) : comments !== null ?(
         
        <div> 
            {comments.map(comm => 
            <div key={comm.id}>
                <h5>{comm.email}</h5>
                <div>{comm.body}</div>
            </div>
            )}
        </div>
      ) : (
        <div>no comments</div>
      )
      }
    </div>
  );
};

export default PostIdPage;
